import { render, staticRenderFns } from "./BoxContent2.vue?vue&type=template&id=1e8072e6&scoped=true"
import script from "./BoxContent2.vue?vue&type=script&lang=js"
export * from "./BoxContent2.vue?vue&type=script&lang=js"
import style0 from "./BoxContent2.vue?vue&type=style&index=0&id=1e8072e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8072e6",
  null
  
)

export default component.exports